import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { AnimatedTextField, Box, GradientIcon, IconButton, Typography } from 'seagull';
import { ReturnArrow } from 'seagull/icons/arrows';
import { Search } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './AiSearchInput.module.scss';
export const GetAiSearchInputTID = (parentTestId)=>getTestIds(parentTestId);
export const AiSearchInput = (param)=>{
    let { testId, placeholder, suggestions, lastQuery, isSubmitting, filterEditedSinceLastSearch, onSubmit, submitAriaLabel, filtersEditedLabel, biPrefix } = param;
    const { AiSearchInputTestIds } = useMemo(()=>GetAiSearchInputTID(testId), [
        testId
    ]);
    const [value, setValue] = useState(lastQuery);
    useEffect(()=>{
        setValue(lastQuery);
    }, [
        lastQuery
    ]);
    const trimmedValue = value.trim();
    const showSubmitCue = trimmedValue !== '' && trimmedValue !== lastQuery;
    const showFiltersEditedBadge = filterEditedSinceLastSearch && trimmedValue === lastQuery;
    const isFilled = showSubmitCue && !isSubmitting;
    const isQueryActive = trimmedValue !== '' && !showFiltersEditedBadge;
    const handleChange = (event)=>{
        setValue(event.target.value);
    };
    const handleSubmit = ()=>{
        if (trimmedValue === '') return;
        onSubmit(trimmedValue);
    };
    const handleKeyDown = (event)=>{
        if (event.key !== 'Enter') return;
        event.preventDefault();
        handleSubmit();
    };
    return /*#__PURE__*/ _jsx(Box, {
        testId: AiSearchInputTestIds.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsxs(Box, {
            className: cn(styles.pill, {
                [styles.filled]: isFilled,
                [styles.processing]: isSubmitting
            }),
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.searchIcon,
                    children: /*#__PURE__*/ _jsx(GradientIcon, {
                        icon: /*#__PURE__*/ _jsx(Search, {
                            size: 20
                        }),
                        size: 20,
                        animated: isQueryActive
                    })
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.field,
                    children: /*#__PURE__*/ _jsx(AnimatedTextField, {
                        testId: AiSearchInputTestIds.TextField(),
                        bi: {
                            name: "".concat(biPrefix, "_query")
                        },
                        suggestions: suggestions,
                        value: value,
                        onChange: handleChange,
                        placeholder: placeholder,
                        className: styles.animatedField,
                        inputRootClass: styles.bareInput,
                        inputProps: {
                            onKeyDown: handleKeyDown,
                            className: cn(styles.inputElement, {
                                [styles.inputElementMuted]: showFiltersEditedBadge
                            })
                        }
                    })
                }),
                showSubmitCue && /*#__PURE__*/ _jsx(Box, {
                    testId: AiSearchInputTestIds.SubmitCue(),
                    className: styles.submitCue,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        bi: {
                            name: "".concat(biPrefix, "_submit_cue")
                        },
                        onClick: handleSubmit,
                        size: "small",
                        skin: "primaryTransparent",
                        "aria-label": submitAriaLabel,
                        children: /*#__PURE__*/ _jsx(ReturnArrow, {
                            size: 16
                        })
                    })
                }),
                showFiltersEditedBadge && /*#__PURE__*/ _jsx(Box, {
                    testId: AiSearchInputTestIds.FiltersEditedBadge(),
                    className: styles.filtersEditedBadge,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: filtersEditedLabel
                    })
                })
            ]
        })
    });
};
